import { configureStore } from "@reduxjs/toolkit";

/*
|--------------------------------------------------------------------------
| EXISTING REDUCERS
|--------------------------------------------------------------------------
*/

// import authReducer from "./auth/authSlice";
// import customerReducer from "./customer/customerSlice";
// import inventoryReducer from "./inventory/inventorySlice";

/*
|--------------------------------------------------------------------------
| BILLING REDUCERS
|--------------------------------------------------------------------------
*/

import {
  billingCommonReducer,
  quotationReducer,
  proformaInvoiceReducer,
  saleOrderReducer,
  deliveryChallanReducer,
  saleInvoiceReducer,
  billingPaymentReducer,
  saleReturnReducer,
  billingImportReducer,
  billingReportReducer,
  billingSettingsReducer,
  saleInvoicePaymentReducer,
  saleInvoiceStockReducer,
  customerLedgerReducer,
  paymentAllocationReducer,
  creditNoteReducer,
  supplierLedgerReducer,
  debitNoteReducer,
  paymentOutReducer,
  purchaseBillReducer,
  supplierReducer,
  supplierPayableReducer,
  purchaseReportReducer,
  gstReportReducer,
} from "./billing";
import { dashboardReducer } from "./dashboard";
import { orderManagementReducer } from "./orderManagement";

import platformAuthReducer from "./platformAuth/platformAuthSlice";

import platformBusinessReducer from "./platformBusiness/platformBusinessSlice";

import platformDashboardReducer from "./platformDashboard/platformDashboardSlice";

import tenantProfileReducer from "./tenantProfile/tenantProfileSlice";

import { platformTenantUserReducer } from "./platformTenantUser";
import { platformActivityReducer } from "./platformActivity";
import platformSettingsReducer from "./platformSettings/platformSettingsSlice";
import platformSubscriptionPlanReducer from "./platformSubscriptionPlan/platformSubscriptionPlanSlice";
import subscriptionReducer from "./tenantSubscription/subscriptionSlice";
import employeeReducer from "./employee/employeeSlice";

import employeeSalaryReducer from "./employee/employeeSalarySlice";

import employeeAdvanceReducer from "./employee/employeeAdvanceSlice";

import employeeLeaveReducer from "./employee/employeeLeaveSlice";

import employeeAttendanceReducer from "./employee/employeeAttendanceSlice";

import platformTenantSubscriptionReducer from "./platformSubscriptionPlan/platformTenantSubscriptionSlice";
import roleReducer from "./role/roleSlice";
import platformBusinessPartnerLeadReducer from "./platform/platformBusinessPartnerLeadSlice";

import platformSellDeviceLeadReducer from "./platform/platformSellDeviceLeadSlice";
import platformSupportReducer from
  "./platform/platformSupportSlice";
/*
|--------------------------------------------------------------------------
| STORE
|--------------------------------------------------------------------------
*/

const store = configureStore({
  reducer: {
    /*
        |--------------------------------------------------------------------------
        | EXISTING REDUCERS
        |--------------------------------------------------------------------------
        */

    // auth: authReducer,
    // customer: customerReducer,
    // inventory: inventoryReducer,

    /*
        |--------------------------------------------------------------------------
        | BILLING
        |--------------------------------------------------------------------------
        */

    billingCommon: billingCommonReducer,

    quotation: quotationReducer,

    proformaInvoice: proformaInvoiceReducer,

    saleOrder: saleOrderReducer,

    deliveryChallan: deliveryChallanReducer,

    saleInvoice: saleInvoiceReducer,

    billingPayment: billingPaymentReducer,

    saleReturn: saleReturnReducer,

    billingImport: billingImportReducer,

    billingReport: billingReportReducer,

    billingSettings: billingSettingsReducer,

    saleInvoicePayment: saleInvoicePaymentReducer,
    saleInvoiceStock: saleInvoiceStockReducer,
    customerLedger: customerLedgerReducer,
    paymentAllocation: paymentAllocationReducer,
    creditNote: creditNoteReducer,
    supplierLedger: supplierLedgerReducer,
    debitNote: debitNoteReducer,
    paymentOut: paymentOutReducer,
    purchaseBill: purchaseBillReducer,
    supplier: supplierReducer,
    supplierPayable: supplierPayableReducer,
    purchaseReport: purchaseReportReducer,
    gstReport: gstReportReducer,
    dashboard: dashboardReducer,
    orderManagement: orderManagementReducer,
    platformAuth: platformAuthReducer,

    platformBusiness: platformBusinessReducer,

    platformDashboard: platformDashboardReducer,
    tenantProfile: tenantProfileReducer,

    platformTenantUser: platformTenantUserReducer,
    platformActivity: platformActivityReducer,
    platformSettings: platformSettingsReducer,
    platformSubscriptionPlan: platformSubscriptionPlanReducer,
    tenantSubscription: subscriptionReducer,

    employee: employeeReducer,

    employeeSalary: employeeSalaryReducer,

    employeeAdvance: employeeAdvanceReducer,

    employeeLeave: employeeLeaveReducer,

    employeeAttendance: employeeAttendanceReducer,
    platformTenantSubscription: platformTenantSubscriptionReducer,
    role: roleReducer,
    platformBusinessPartnerLead: platformBusinessPartnerLeadReducer,

    platformSellDeviceLead: platformSellDeviceLeadReducer,
    platformSupport:
  platformSupportReducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        /*
                    |--------------------------------------------------------------------------
                    | FILE UPLOAD SUPPORT
                    |--------------------------------------------------------------------------
                    |
                    | File and FormData are non-serializable.
                    | They are passed inside billing import and image upload thunks.
                    |--------------------------------------------------------------------------
                    */

        ignoredActions: [
          "billingImport/uploadBillingImport/pending",
          "billingImport/uploadBillingImport/fulfilled",
          "billingImport/uploadBillingImport/rejected",

          "billingSettings/uploadBillingLogo/pending",
          "billingSettings/uploadBillingLogo/fulfilled",
          "billingSettings/uploadBillingLogo/rejected",

          "billingSettings/uploadBillingSignature/pending",
          "billingSettings/uploadBillingSignature/fulfilled",
          "billingSettings/uploadBillingSignature/rejected",
        ],

        ignoredActionPaths: ["meta.arg.file", "payload.file"],
      },
    }),

  devTools: process.env.NODE_ENV !== "production",
});

export default store;
